import type { FaireProductEntity } from "../../entity_types/product";

export const p_7mtpd3b6xy: FaireProductEntity = {
  token: "p_7mtpd3b6xy",
  type: "product",
  name: "Lucid Flow Maxi Dress - Burgundy",
  brandToken: "b_2zdmtoaf",
  brandName: "The Handloom",
  imageUrl:
    "https://cdn.faire.com/fastly/c53138b26bd5ef87e3caa95059801e6d078191b2734877457d498c199ce6fe8a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c35086e3885e566f5e921169c9cb23048769bd907cf0eb0a3f1bca2021e40ef7.jpeg",
    "https://cdn.faire.com/fastly/8c94a510704fefe3b565f70420b648e5e4bcb2ef88c6b12dfead53a660697e7d.jpeg",
    "https://cdn.faire.com/fastly/f840e4b8b6587a0fdf52edba1b4248999eab3343205bf3a59cb05dbda7037678.jpeg",
    "https://cdn.faire.com/fastly/899cf612c4a8723b7a2178864e8069963faf396eb2aa10b019d53c89b63a84b7.jpeg",
    "https://cdn.faire.com/fastly/d6a0785d856c002e087cfd93fc8b5d22e10e2d09515e7fb407e9b0b7894342dd.jpeg",
    "https://cdn.faire.com/fastly/9c89ecab1ae9bec856a61432d57487d686337a09542a7eaa5d1377fce61ed536.jpeg",
    "https://cdn.faire.com/fastly/22e4c7bf5d777a16492dd40695484165198f5322080002ad5f183d3b0ab4417e.jpeg",
  ],
  priceDollars: 94,
  description:
    "This voluminous summer style features a delicate V-neckline, slender adjustable straps, and a graceful silhouette. The lightweight fabric offers a subtle sheen and a luxurious drape. An elegant open-back detail adds sophistication, making it perfect for both relaxed days and evening occasions.\n\n- Crafted from TENCEL™ Luxe and ECOVISCOSE fabric\n- Voluminous summer style\n- V-neckline\n- Slender adjustable straps\n- Open-back detail\n\nThis piece is crafted from premium Tencel fabric. To maintain its quality, please iron on the reverse side at a low temperature.\n\n* The model wearing the product in the photos is 5'11\" (180 cm) tall, and wears size S/M.\n",
  tags: [],
  msrpDollars: 188,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:20:03.506Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
